export default __webpack_public_path__ + "static/media/Zone-5-Master-Plan-Type-E.bc3d3707.png";